import axios from "axios";
import {
  GET_KONSELOR_SESSION_FAIL,
  GET_KONSELOR_SESSION_REQUEST,
  GET_KONSELOR_SESSION_RESET,
  GET_KONSELOR_SESSION_SUCCESS,
  POST_KONSELOR_SESSION_FAIL,
  POST_KONSELOR_SESSION_REQUEST,
  POST_KONSELOR_SESSION_RESET,
  POST_KONSELOR_SESSION_SUCCESS,
} from "../constants/KonselorSessionConstants";
import {
  API_GET_RESULT_SESSION_KONSELOR,
  API_POST_KONSELOR_SESSION,
} from "../init/urlApi";
import { UserDatPduliaDecode } from "../function/base64Function";

// untuk kritik dan saran
// Get Konselor Session
// export const RGetKonselorSession = () => async (dispatch) => {
//   dispatch({
//     type: GET_KONSELOR_SESSION_RESET,
//   });
// };

// export const GetKonselorSession = () => async (dispatch) => {
//   //   const { token, session } = userDataLocalStorage();
//   let token = "123qwer";
//   try {
//     dispatch({
//       type: GET_KONSELOR_SESSION_REQUEST,
//     });

//     const config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       // params: {
//       //   projectCode: projectCode,
//       //   methodId: methodId,
//       // },
//     };
//     const { data: data } = await axios.get(
//       API_GET_RESULT_SESSION_KONSELOR(),
//       config
//     );

//     dispatch({
//       type: GET_KONSELOR_SESSION_SUCCESS,
//       payload: data?.data,
//     });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;

//     dispatch({
//       type: GET_KONSELOR_SESSION_FAIL,
//       payload: message,
//     });
//   }
// };

// Post Konselor Session
export const RPostKonselorSession = () => async (dispatch) => {
  dispatch({
    type: POST_KONSELOR_SESSION_RESET,
  });
};

export const PostKonselorSession =
  (conclusion, suggestion) => async (dispatch) => {
    const { token, typeUser, session } = UserDatPduliaDecode();

    try {
      dispatch({
        type: POST_KONSELOR_SESSION_REQUEST,
      });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data: data } = await axios.post(
        API_POST_KONSELOR_SESSION(),
        {
          sessionId: session,
          conclusion: conclusion,
          suggestion: suggestion,
          notes: "-",
        },
        config
      );

      dispatch({
        type: POST_KONSELOR_SESSION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: POST_KONSELOR_SESSION_FAIL,
        payload: message,
      });
    }
  };
